<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <iframe [src]="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>